var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-div",class:{'mobile': _vm.device == 'mobile'},style:({ backgroundImage: 'url(' + _vm.img + ')' })})}
var staticRenderFns = []

export { render, staticRenderFns }